/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Button, Badge, Card, Row, Col, CardBody, CardHeader, Container, Form, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile"
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import SweetAlert from "react-bootstrap-sweetalert";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../Style.css"

export default function IndexDokumentPettycash(props) {
    // const warehouse = localStorage.warehouse;
    const token = localStorage.token;
    // const username = localStorage.username;
    const codepettycash = localStorage.cp;
    let history = useHistory();
    const [rowIndex, setRowIndex] = useState(0);
    const [AllPettyCash, setAllPettyCash] = useState([]);
    const [nameAsset, setNameAsset] = useState("");
    const [codeAsset, setCodeAsset] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerpage] = useState(10);
    const [totalItem, setTotalItem] = useState(0);
    const [currentSort, setCurrentSort] = useState("");
    const [loading2, setLoading2] = useState(false)
    const [modalImage, setModalImage] = useState(false);
    const [bukti, setBukti] = useState("");

    let paginationOption = {
        page: page,
        alwaysShowAllBtns: true,
        override: true,
        showTotal: true,
        withFirstAndLast: false,
        sizePerPage: perPage,
        totalSize: totalItem,
        onPageChange: (page) => {
            updateDataTable(page, perPage, currentSort, nameAsset, codeAsset, startDate, endDate);
        },
        sizePerPageRenderer: () => (
            <div className="dataTables_length" id="datatable-basic_length">
                <label>
                    Show{" "}
                    {
                        <select
                            name="datatable-basic_length"
                            aria-controls="datatable-basic"
                            className="form-control form-control-sm"
                            onChange={(e) => {
                                updateDataTable(page, e.target.value, currentSort)
                            }}
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                    }{" "}
                    entries.
                </label>
            </div>
        ),
    }

    const updateDataTable = (page, perPage, sort, nameAsset, codeAsset, startDate, endDate) => {
        getAsset(page, perPage, sort, nameAsset, codeAsset, startDate, endDate);
        setPage(page);
        setPerpage(perPage);
        setRowIndex((page - 1) * perPage);
        setCurrentSort(sort);
        setNameAsset(nameAsset);
        setCodeAsset(codeAsset);
        setStartDate(startDate);
        setEndDate(endDate);
    }

    const handleTableChange = (type, { sortField, sortOrder }) => {
        if (type === "sort") {
            let sort = `${sortField} ${sortOrder}`
            updateDataTable(page, perPage, sort, nameAsset, codeAsset, startDate, endDate)
        }
    }


    useEffect(() => {
        getAllDokumentPettyCash(page, perPage, currentSort, "", "", "", "", "");
    }, []);

    const getAllDokumentPettyCash = (page) => {
        let filter = {
            petty_cash_id: props.match.params.id,
        }
        const data = filter;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/petty-cash/item`, data, {
            headers
        })
            .then(data => {
                setAllPettyCash(data.data.response);
                setPage(data.data.current_page + 1);
                setPerpage(data.data.per_page);
                setTotalItem(data.data.total_item);
            })
            .catch(function (error) {
                setAllPettyCash(error.response.data.response)
            })
    }

    const handleClearPettyCash = (flag) => {
        setLoading2(true)
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/petty-cash/end-item/${codepettycash}`, { headers })
            .then((res) => {
                // getAllDokumentPettyCash()
                console.log("📍 Petty Cash Selesai", res.data);
                setTimeout(() => history.push(`/mobile/pettycash/page`), 1000);
                setLoading2(false)
            })
            // .catch((err) => console.error("❌ Gagal update tracking", err));
            .catch(function (error) {
                setLoading2(false)
            });
    };


    const handleDeletePettyCash = (id) => {
        setLoading2(true)
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/petty-cash/delete-item/${id}`, { headers })
            .then((res) => {
                console.log("📍 Petty Cash Delete", res.data);
                getAllDokumentPettyCash()

                // setTimeout(() => history.push(`/mobile/pettycash/page`), 1000);
                setLoading2(false)
            })
            // .catch((err) => console.error("❌ Gagal update tracking", err));
            .catch(function (error) {
                setLoading2(false)
            });
    };

    const formatRupiah = (money) => {
        return new Intl.NumberFormat('id-ID',
            { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
        ).format(money);
    }

    const openImageModal = (url) => {
        setBukti(url);
        setModalImage(true);
    };

    const closeImageModal = () => {
        setModalImage(false);
    };

    return (
        <div style={{ overflow: "hidden" }}>
            {/* {alert} */}
            <SimpleHeaderMobile to="/mobile/pettycash/page" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardHeader>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <h2>Dokumen Petty Cash</h2>
                                    <div style={{ textAlign: 'left' }} className="d-lg-block d-none">
                                        <Link className="btn btn-link" to="/mobile/pettycash/page">
                                            <i className="fa fa-arrow-circle-left fa-2x" />
                                        </Link>
                                    </div>
                                    <div style={{ textAlign: "right" }} className="d-lg-block d-none">
                                        <Link className="btn btn-danger" to="/mobile/pettycash/create">
                                            <i className="fa fa-plus" aria-hidden="true" /> Tambah
                                        </Link>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {AllPettyCash === null ? (
                                    <div className="d-lg-none d-xl-none">
                                        <CardHeader>
                                            <center><h3>DATA NOT FOUND</h3></center>
                                        </CardHeader>
                                    </div>
                                ) : (
                                    <Form>
                                        <PerfectScrollbar>
                                            <div
                                                className="d-lg-none d-xl-none"
                                                style={{ top: 100, zIndex: 3, maxHeight: "35rem", paddingTop: "0.5rem" }}
                                            >
                                                {AllPettyCash.map((v) => {

                                                    return (
                                                        // 
                                                        // <Link to={dynamicLink} key={v.id}>
                                                        <Card className="bg-gradient-info mb-3 shadow border-0">
                                                            <CardBody className="p-3">
                                                                <Row className="align-items-center">
                                                                    <Col>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <h3 className="text-white mb-0">{formatRupiah(v.nominal)}</h3>
                                                                            <Button
                                                                                color="secondary"
                                                                                size="sm"
                                                                                className="btn-icon btn-sm"
                                                                                onClick={() => openImageModal(v.bukti_url)}
                                                                            >
                                                                                <i className="fa fa-eye" style={{ cursor: "pointer" }} aria-hidden="true" />
                                                                            </Button>{/* </Badge> */}
                                                                        </div>

                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div
                                                                                className="text-white font-weight-bold"
                                                                                style={{
                                                                                    overflow: "hidden",
                                                                                    textOverflow: "ellipsis",
                                                                                    display: "-webkit-box",
                                                                                    WebkitLineClamp: 1,
                                                                                    WebkitBoxOrient: "vertical",
                                                                                    fontSize: "1rem",
                                                                                }}
                                                                            >
                                                                                {v.keterangan}
                                                                            </div>
                                                                            <Button
                                                                                color="danger"
                                                                                size="sm"
                                                                                className="btn-icon btn-sm"
                                                                                onClick={() => handleDeletePettyCash(v.id)}
                                                                            >
                                                                                <i className="fas fa-trash-alt" />
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>

                                                        // </Link>
                                                    );
                                                })}
                                            </div>
                                        </PerfectScrollbar>
                                    </Form>
                                )}
                            </CardBody>
                        </Card>
                    </div>
                </Row>
            </Container>
            <nav className="navbar navbar-bottom bg-white navbar-expand fixed-bottom d-md-none d-lg-none d-xl-none">
                <ul className="navbar-nav nav-justified w-100 position-relative">
                    <li className="nav-item">
                        <a href="/mobile/staff-absen" className="nav-link text-center">
                            <i className="fas fa-home fa-lg d-block mb-1" />
                            <span className="small">Home</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <div className="fab-center-button">
                            <Button
                                color="success"
                                disabled={loading2}
                                onClick={() => handleClearPettyCash()}
                                className="rounded-circle p-0 d-flex justify-content-center align-items-center"
                                style={{ height: "70px", width: "70px" }}
                            >
                                <i className="fas fa-check fa-2x" />
                            </Button>
                        </div>
                    </li>

                    <li className="nav-item">
                        <a href="/mobile/profile" className="nav-link text-center">
                            <i className="fas fa-user fa-lg d-block mb-1" />
                            <span className="small">Akun</span>
                        </a>
                    </li>
                </ul>
            </nav>
            <div className="d-lg-none d-xl-none">
                <Link
                    style={{
                        position: 'fixed',
                        bottom: 100,
                        right: 20,
                        height: 45,
                        width: 45,
                        borderRadius: 12,
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                    className="btn-danger text-center fixed-whatsapp encepnurdin"
                    to="/mobile/pettycash/upload"
                >
                    <i className="fa fa-plus fa-2x" aria-hidden="true" />
                </Link>
            </div>
            <Modal isOpen={modalImage} toggle={closeImageModal} size="lg">
                <ModalHeader toggle={closeImageModal}>Preview Gambar</ModalHeader>
                <ModalBody>
                    <img src={bukti} alt="preview" style={{ width: "100%", height: "auto" }} />
                </ModalBody>
            </Modal>
        </div>
    );
}
